import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';

import workpatternsLDProvider from './WpLaunchdarkly/workpatternsLDProvider';
import { isZoomAndWindows } from './WpLaunchdarkly/utils';

import React from 'react';
// import { render } from 'react-dom' TODO: This isn't needed because we load ReactDOM.
// import ReactDOM from 'react-dom';
import Root from './Root';

import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';
import LogRocket from 'logrocket';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('reactroot');
  const root = createRoot(node);

  const data = JSON.parse(node.getAttribute('data'));
  if (data.user && !data.user.isPredictiveIndexEmployee) {
    LogRocket.init('dzcoy1/pi-vyvd9', {
      rootHostname: 'predictiveindex.com',
    });
    LogRocket.identify(data.user.email, {
      userGuid: data.user.piUserGuid,
      name: data.user.full_name,
      email: data.user.email,
    });
  }

  const providerCreator = isZoomAndWindows() ? workpatternsLDProvider : asyncWithLDProvider;

  // This is saying that if we're on a predictiveindex.com url
  // then set the cookie domain to .predictiveindex.com instead of the default which would be
  // perform.predictiveindex.com or staging-perform.predictiveindex.com, etc
  // If we set the domain to .predictiveindex.com then Auth0 will share the login with
  // app.predictiveindex.com
  const cookieDomain = (() => {
    const hostName = window.location.hostname;
    if (hostName.endsWith('.predictiveindex.com')) return '.predictiveindex.com';
    return;
  })();

  // Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
  // for a full list of the available properties on the provider
  const providerConfig: Auth0ProviderOptions = {
    domain: data.app.auth0_domain,
    clientId: data.app.auth0_clientId,
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: data.app.auth0_audience,
    },
    cookieDomain,
    cache: (o => ({
      get: id => o[id],
      set: (id, val) => (o[id] = val),
      remove: id => {
        delete o[id];
      },
      allKeys: () => Object.keys(o),
    }))({}),
  };

  if (data.user) {
    (async () => {
      const tracking_properties = data.user.tracking_properties;
      const {
        split_tests_list: split_tests_list_value,
        split_tests: split_tests_value,
        ...tracking_properties_without_split_tests
      } = tracking_properties;
      const LDProvider = await providerCreator({
        clientSideID: data.app.launchDarklyClientID,
        context: {
          kind: 'user',
          key: data.user.global_id,
          name: data.user.full_name,
          email: data.user.email,
          ...tracking_properties_without_split_tests,
        },
        options: {},
      });

      root.render(
        <Auth0Provider {...providerConfig}>
          <LDProvider>
            <Root data={data} />
          </LDProvider>
        </Auth0Provider>
      );
    })();
  } else {
    root.render(
      <Auth0Provider {...providerConfig}>
        <Root data={data} />
      </Auth0Provider>
    );
  }
});
